import React from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './pages/core/Login';
import './index.css';
import TaroffOrderTemplatesEdit from './pages/orders-templates/TaroffOrderTemplatesEdit';
import TaroffOrderTemplatesDelete from './pages/orders-templates/TaroffOrderTemplatesDelete';
import TaroffOrderTemplates from './pages/orders-templates/TaroffOrderTemplates';
import TaroffShopsEdit from './pages/shops/TaroffShopsEdit';
import TaroffCities from './pages/locations/TaroffCities';
import Home from './pages/core/Home';
import TaroffShopsNew from './pages/shops/TaroffShopsNew';
import TaroffOrders from './pages/orders/TaroffOrders';
import TaroffSmsCanceledOrders from './pages/orders-sms/TaroffSmsCanceledOrders';
import TaroffOrderTemplatesNew from './pages/orders-templates/TaroffOrderTemplatesNew';
import TaroffShops from './pages/shops/TaroffShops';
import TaroffProvincesDelete from './pages/locations/TaroffProvincesDelete';
import TaroffProvincesEdit from './pages/locations/TaroffProvincesEdit';
import TaroffOrderStates from './pages/orders/TaroffOrderStates';
import TaroffDeliverTimesNew from './pages/delivery/TaroffDeliverTimesNew';
import TaroffOrdersSetPeik from './pages/peik/TaroffOrdersSetPeik';
import TaroffUsers from './pages/users/TaroffUsers';
import TaroffOrdersPeikSent from './pages/peik/TaroffOrdersPeikSent';
import TaroffOrdersPeikDelivered from './pages/peik/TaroffOrdersPeikDelivered';
import TaroffOrdersPeikRejected from './pages/peik/TaroffOrdersPeikRejected';
import TaroffPaymentMethodsEdit from './pages/financial/TaroffPaymentMethodsEdit';
import TaroffCitiesEdit from './pages/locations/TaroffCitiesEdit';
import TaroffOrdersPeikWaiting from './pages/peik/TaroffOrdersPeikWaiting';
import TaroffTransactionTypes from './pages/financial/TaroffTransactionTypes';
import MembershipTransactionTypesDelete from './pages/financial/MembershipTransactionTypesDelete';
import MembershipTransactionTypesNew from './pages/financial/MembershipTransactionTypesNew';
import TaroffOrdersPeik from './pages/peik/TaroffOrdersPeik';
import MembershipTransactionTypesEdit from './pages/financial/MembershipTransactionTypesEdit';
import TaroffOrdersSetReady from './pages/orders/TaroffOrdersSetReady';
import TaroffOrdersEdit from './pages/orders/TaroffOrdersEdit';
import TaroffOrdersSetCancel from './pages/orders/TaroffOrdersSetCancel';
import TaroffPeiksEdit from './pages/peik/TaroffPeiksEdit';
import TaroffZonesNew from './pages/locations/TaroffZonesNew';
import TaroffZonesEdit from './pages/locations/TaroffZonesEdit';
import TaroffPeiksNew from './pages/peik/TaroffPeiksNew';
import TaroffOrdersPeikSetAccepted from './pages/peik/TaroffOrdersPeikSetAccepted';
import TaroffOrdersPeikSetNotAccepted from './pages/peik/TaroffOrdersPeikSetNotAccepted';
import TaroffOrdersPeikSetRejected from './pages/peik/TaroffOrdersPeikSetRejected';
import TaroffOrdersPeikSetDelivered from './pages/peik/TaroffOrdersPeikSetDelivered';
import TaroffOrdersPeikSetInit from './pages/peik/TaroffOrdersPeikSetInit';
import SystemTaroffTaroffCollectStatesEdit from './pages/collect/SystemTaroffTaroffCollectStatesEdit';
import TaroffOrderStateChangesReport from './pages/orders/TaroffOrderStateChangesReport';
import TaroffTransactionsNew from './pages/financial/TaroffTransactionsNew';
import TaroffOrdersSpecialReport from './pages/orders/TaroffOrdersSpecialReport';
import TaroffCarriers from './pages/delivery/TaroffCarriers';
import TaroffOrdersFinancial from './pages/orders/TaroffOrdersFinancial';
import TaroffDeliverTimes from './pages/delivery/TaroffDeliverTimes';
import TaroffProvinces from './pages/locations/TaroffProvinces';
import TaroffOrdersLogs from './pages/orders/TaroffOrdersLogs';
import TaroffPeiks from './pages/peik/TaroffPeiks';
import TaroffFinancialShopsBalance from './pages/financial/TaroffFinancialShopsBalance';
import TaroffZones from './pages/locations/TaroffZones';
import TaroffCollectStates from './pages/collect/TaroffCollectStates';
import TaroffOrdersNew from './pages/orders/TaroffOrdersNew';
import TaroffSupportRequestsArchive from './pages/support/TaroffSupportRequestsArchive';
import TaroffOrdersCopy from './pages/orders/TaroffOrdersCopy';
import TarottPeikShifts from './pages/peik/TarottPeikShifts';
import TaroffUsersEdit from './pages/users/TaroffUsersEdit';
import TaroffOrderStateChanges from './pages/orders/TaroffOrderStateChanges';
import TaroffPeikShiftsEdit from './pages/peik/TaroffPeikShiftsEdit';
import TaroffOrdersSetZone from './pages/orders/TaroffOrdersSetZone';
import TaroffPaymentMethods from './pages/financial/TaroffPaymentMethods';
import TaroffOrdersDelete from './pages/orders/TaroffOrdersDelete';
import TaroffOrderStatesEdit from './pages/orders/TaroffOrderStatesEdit';
import TaroffServiceTokens from './pages/users/TaroffServiceTokens';
import TaroffSmsOrdersEdit from './pages/orders-sms/TaroffSmsOrdersEdit';
import TaroffTaroffTransactions from './pages/financial/TaroffTaroffTransactions';
import TaroffOrdersPeikConfirmOrder from './pages/peik/TaroffOrdersPeikConfirmOrder';
import TaroffPeikCollectRequests from './pages/collect/TaroffPeikCollectRequests';
import TaroffRegisterRequests from './pages/users/TaroffRegisterRequests';
import TaroffOrdersPeikReady from './pages/peik/TaroffOrdersPeikReady';
import TaroffTransactions from './pages/financial/TaroffTransactions';
import TaroffShopServiceTokensNew from './pages/shops/TaroffShopServiceTokensNew';
import TaroffOrdersView from './pages/orders/TaroffOrdersView';
import TaroffShopsDelete from './pages/shops/TaroffShopsDelete';
import TaroffCarriersEdit from './pages/delivery/TaroffCarriersEdit';
import TaroffGatewayStates from './pages/financial/TaroffGatewayStates';
import TaroffOrderStatesNew from './pages/orders/TaroffOrderStatesNew';
import TaroffOrdersPeikAccepted from './pages/peik/TaroffOrdersPeikAccepted';
import TaroffShopServiceTokensDelete from './pages/shops/TaroffShopServiceTokensDelete';
import TaroffOrdersPeikCancel from './pages/peik/TaroffOrdersPeikCancel';
import TaroffPeik from './pages/peik/TaroffPeik';
import TaroffOrdersReceivedSms from './pages/orders-sms/TaroffOrdersReceivedSms';
import TaroffSupportRequestsTypes from './pages/support/TaroffSupportRequestsTypes';
import TaroffSmsOrders from './pages/orders-sms/TaroffSmsOrders';
import TaroffSupportRequestsStates from './pages/support/TaroffSupportRequestsStates';
import TaroffSupportRequests from './pages/support/TaroffSupportRequests';
import TaroffTasks from './pages/tasks/TaroffTasks';
import TaroffPeikShiftsNew from './pages/peik/TaroffPeikShiftsNew';
import TaroffPeikOrdersNewWithShift from './pages/peik/TaroffPeikOrdersNewWithShift';
import SystemTaroffTaroffCollectRequestsEdit from './pages/collect/SystemTaroffTaroffCollectRequestsEdit';
import TaroffCollectStatesNew from './pages/collect/TaroffCollectStatesNew';
import TaroffCollectTimes from './pages/collect/TaroffCollectTimes';
import TaroffCollectTimesNew from './pages/collect/TaroffCollectTimesNew';
import SystemTaroffTaroffCollectTimesEdit from './pages/collect/SystemTaroffTaroffCollectTimesEdit';
import TaroffPrePrintBarcodes from './pages/barcodes/TaroffPrePrintBarcodes';
import TaroffAiAnalyst from './pages/ai/TaroffAiAnalyst';


const RequireAuth = ({ children }) => {
    const token = localStorage.getItem('admin_auth_token');
    // const token = document.cookie.split(';').find(c => c.trim().startsWith('taroff-authentication-token='))?.split('=')[1];
    if (!token) {
        return <Navigate to='/admin/site-admin/login' replace />;
    }
    return children;
};


const router = createBrowserRouter([
    { path: '/admin/site-admin/login', element: <Login /> },
    { path: '/', element: <RequireAuth><Dashboard /></RequireAuth>, children: [
        { path: '/admin/site-admin/taroff-order-templates/edit', element: <TaroffOrderTemplatesEdit /> },
        { path: '/admin/site-admin/taroff-order-templates/delete', element: <TaroffOrderTemplatesDelete /> },
        { path: '/admin/site-admin/taroff/order-templates', element: <TaroffOrderTemplates /> },
        { path: '/admin/site-admin/taroff-shops/edit', element: <TaroffShopsEdit /> },
        { path: '/admin/site-admin/taroff/cities', element: <TaroffCities /> },
        { path: '/admin/site-admin/', element: <Home /> },
        { path: '/admin/site-admin/taroff-shops/new', element: <TaroffShopsNew /> },
        { path: '/admin/site-admin/taroff/orders', element: <TaroffOrders /> },
        { path: '/admin/site-admin/taroff/sms-canceled-orders', element: <TaroffSmsCanceledOrders /> },
        { path: '/admin/site-admin/taroff-order-templates/new', element: <TaroffOrderTemplatesNew /> },
        { path: '/admin/site-admin/taroff/shops', element: <TaroffShops /> },
        { path: '/admin/site-admin/taroff-provinces/delete', element: <TaroffProvincesDelete /> },
        { path: '/admin/site-admin/taroff-provinces/edit', element: <TaroffProvincesEdit /> },
        { path: '/admin/site-admin/taroff/order-states', element: <TaroffOrderStates /> },
        { path: '/admin/site-admin/taroff-deliver-times/new', element: <TaroffDeliverTimesNew /> },
        { path: '/admin/site-admin/taroff-orders/set-peik', element: <TaroffOrdersSetPeik /> },
        { path: '/admin/site-admin/taroff/users', element: <TaroffUsers /> },
        { path: '/admin/site-admin/taroff/orders-peik-sent', element: <TaroffOrdersPeikSent /> },
        { path: '/admin/site-admin/taroff/orders-peik-delivered', element: <TaroffOrdersPeikDelivered /> },
        { path: '/admin/site-admin/taroff/orders-peik-rejected', element: <TaroffOrdersPeikRejected /> },
        { path: '/admin/site-admin/taroff-payment-methods/edit', element: <TaroffPaymentMethodsEdit /> },
        { path: '/admin/site-admin/taroff-cities/edit', element: <TaroffCitiesEdit /> },
        { path: '/admin/site-admin/taroff/orders-peik-waiting', element: <TaroffOrdersPeikWaiting /> },
        { path: '/admin/site-admin/taroff/transaction-types', element: <TaroffTransactionTypes /> },
        { path: '/admin/site-admin/membership-transaction-types/delete', element: <MembershipTransactionTypesDelete /> },
        { path: '/admin/site-admin/membership-transaction-types/new', element: <MembershipTransactionTypesNew /> },
        { path: '/admin/site-admin/taroff/orders-peik', element: <TaroffOrdersPeik /> },
        { path: '/admin/site-admin/membership-transaction-types/edit', element: <MembershipTransactionTypesEdit /> },
        { path: '/admin/site-admin/taroff-orders/set-ready', element: <TaroffOrdersSetReady /> },
        { path: '/admin/site-admin/taroff-orders/edit', element: <TaroffOrdersEdit /> },
        { path: '/admin/site-admin/taroff-orders/set-cancel', element: <TaroffOrdersSetCancel /> },
        { path: '/admin/site-admin/taroff-peiks/edit', element: <TaroffPeiksEdit /> },
        { path: '/admin/site-admin/taroff-zones/new', element: <TaroffZonesNew /> },
        { path: '/admin/site-admin/taroff-zones/edit', element: <TaroffZonesEdit /> },
        { path: '/admin/site-admin/taroff-peiks/new', element: <TaroffPeiksNew /> },
        { path: '/admin/site-admin/taroff-orders/peik-set-accepted', element: <TaroffOrdersPeikSetAccepted /> },
        { path: '/admin/site-admin/taroff-orders/peik-set-not-accepted', element: <TaroffOrdersPeikSetNotAccepted /> },
        { path: '/admin/site-admin/taroff-orders/peik-set-rejected', element: <TaroffOrdersPeikSetRejected /> },
        { path: '/admin/site-admin/taroff-orders/peik-set-delivered', element: <TaroffOrdersPeikSetDelivered /> },
        { path: '/admin/site-admin/taroff-orders/peik-set-init', element: <TaroffOrdersPeikSetInit /> },
        { path: '/admin/site-admin/system-taroff/taroff-collect-states/edit', element: <SystemTaroffTaroffCollectStatesEdit /> },
        { path: '/admin/site-admin/taroff/order-state-changes-report', element: <TaroffOrderStateChangesReport /> },
        { path: '/admin/site-admin/taroff/transactions/new', element: <TaroffTransactionsNew /> },
        { path: '/admin/site-admin/taroff/orders-special-report', element: <TaroffOrdersSpecialReport /> },
        { path: '/admin/site-admin/taroff/carriers', element: <TaroffCarriers /> },
        { path: '/admin/site-admin/taroff/orders-financial', element: <TaroffOrdersFinancial /> },
        { path: '/admin/site-admin/taroff-deliver-times', element: <TaroffDeliverTimes /> },
        { path: '/admin/site-admin/taroff/provinces', element: <TaroffProvinces /> },
        { path: '/admin/site-admin/taroff/orders/logs', element: <TaroffOrdersLogs /> },
        { path: '/admin/site-admin/taroff/peiks', element: <TaroffPeiks /> },
        { path: '/admin/site-admin/taroff/financial/shops-balance', element: <TaroffFinancialShopsBalance /> },
        { path: '/admin/site-admin/taroff/zones', element: <TaroffZones /> },
        { path: '/admin/site-admin/taroff/collect-states', element: <TaroffCollectStates /> },
        { path: '/admin/site-admin/taroff-orders/new', element: <TaroffOrdersNew /> },
        { path: '/admin/site-admin/taroff/support/requests/archive', element: <TaroffSupportRequestsArchive /> },
        { path: '/admin/site-admin/taroff-orders-copy', element: <TaroffOrdersCopy /> },
        { path: '/admin/site-admin/tarott-peik-shifts', element: <TarottPeikShifts /> },
        { path: '/admin/site-admin/taroff-users/edit', element: <TaroffUsersEdit /> },
        { path: '/admin/site-admin/taroff/order-state-changes', element: <TaroffOrderStateChanges /> },
        { path: '/admin/site-admin/taroff-peik-shifts/edit', element: <TaroffPeikShiftsEdit /> },
        { path: '/admin/site-admin/taroff-orders/set-zone', element: <TaroffOrdersSetZone /> },
        { path: '/admin/site-admin/taroff/payment-methods', element: <TaroffPaymentMethods /> },
        { path: '/admin/site-admin/taroff-orders/delete', element: <TaroffOrdersDelete /> },
        { path: '/admin/site-admin/taroff-order-states/edit', element: <TaroffOrderStatesEdit /> },
        { path: '/admin/site-admin/taroff-service-tokens', element: <TaroffServiceTokens /> },
        { path: '/admin/site-admin/taroff-sms-orders/edit', element: <TaroffSmsOrdersEdit /> },
        { path: '/admin/site-admin/taroff/taroff-transactions', element: <TaroffTaroffTransactions /> },
        { path: '/admin/site-admin/taroff-orders/peik-confirm-order', element: <TaroffOrdersPeikConfirmOrder /> },
        { path: '/admin/site-admin/taroff-transactions/new', element: <TaroffTransactionsNew /> },
        { path: '/admin/site-admin/taroff/peik-collect-requests', element: <TaroffPeikCollectRequests /> },
        { path: '/admin/site-admin/taroff-register-requests', element: <TaroffRegisterRequests /> },
        { path: '/admin/site-admin/taroff/orders-peik-ready', element: <TaroffOrdersPeikReady /> },
        { path: '/admin/site-admin/taroff/transactions', element: <TaroffTransactions /> },
        { path: '/admin/site-admin/taroff-shop-service-tokens/new', element: <TaroffShopServiceTokensNew /> },
        { path: '/admin/site-admin/taroff-orders/view', element: <TaroffOrdersView /> },
        { path: '/admin/site-admin/taroff-shops/delete', element: <TaroffShopsDelete /> },
        { path: '/admin/site-admin/taroff-carriers/edit', element: <TaroffCarriersEdit /> },
        { path: '/admin/site-admin/taroff-gateway-states', element: <TaroffGatewayStates /> },
        { path: '/admin/site-admin/taroff-order-states/new', element: <TaroffOrderStatesNew /> },
        { path: '/admin/site-admin/taroff/orders-peik-accepted', element: <TaroffOrdersPeikAccepted /> },
        { path: '/admin/site-admin/taroff-shop-service-tokens/delete', element: <TaroffShopServiceTokensDelete /> },
        { path: '/admin/site-admin/taroff/orders-peik-cancel', element: <TaroffOrdersPeikCancel /> },
        { path: '/admin/site-admin/taroff/peik', element: <TaroffPeik /> },
        { path: '/admin/site-admin/taroff/orders/received-sms', element: <TaroffOrdersReceivedSms /> },
        { path: '/admin/site-admin/taroff/support/requests/types', element: <TaroffSupportRequestsTypes /> },
        { path: '/admin/site-admin/taroff/sms-orders', element: <TaroffSmsOrders /> },
        { path: '/admin/site-admin/taroff/support/requests/states', element: <TaroffSupportRequestsStates /> },
        { path: '/admin/site-admin/taroff/support/requests', element: <TaroffSupportRequests /> },
        { path: '/admin/site-admin/taroff/tasks', element: <TaroffTasks /> },
        { path: '/admin/site-admin/taroff-peik-shifts/new', element: <TaroffPeikShiftsNew /> },
        { path: '/admin/site-admin/taroff/peik-orders-new-with-shift', element: <TaroffPeikOrdersNewWithShift /> },
        { path: '/admin/site-admin/system-taroff/taroff-collect-requests/edit', element: <SystemTaroffTaroffCollectRequestsEdit /> },
        { path: '/admin/site-admin/taroff-collect-states/new', element: <TaroffCollectStatesNew /> },
        { path: '/admin/site-admin/taroff/collect-times', element: <TaroffCollectTimes /> },
        { path: '/admin/site-admin/taroff-collect-times/new', element: <TaroffCollectTimesNew /> },
        { path: '/admin/site-admin/system-taroff/taroff-collect-times/edit', element: <SystemTaroffTaroffCollectTimesEdit /> },
        { path: '/admin/site-admin/taroff/pre-print-barcodes', element: <TaroffPrePrintBarcodes /> },
        { path: '/admin/site-admin/taroff/ai-analyst', element: <TaroffAiAnalyst /> },
    ]
    },
])

function App() {
    return <RouterProvider router={router} />;
}

const root = createRoot(document.getElementById('root'));
root.render(<App />);
